import { useTranslation } from 'react-i18next'

import { useDateLocale, useTimeZone } from '../../../hooks'
import { getCalendarGridItemsByDay } from '../CalendarGrid.utils'
import { CalendarGridBodyMessage } from '../CalendarGridBodyMessage'

import {
  getCalendarGridAgendaDays,
  getCalendarGridAgendaMessage,
  getHasCalendarGridAgendaDays,
} from './CalendarGridAgenda.utils'
import { CalendarGridAgendaDay } from './CalendarGridAgendaDay'
import { CalendarGridAgendaSkeleton } from './CalendarGridAgendaSkeleton'

import * as styles from './CalendarGridAgenda.module.css'

function CalendarGridAgenda({
  days,
  isLoading,
  items,
  message,
  today,
  onClickItem,
  onClickSecondaryLabel,
}) {
  const { t } = useTranslation()

  const locale = useDateLocale()
  const timezone = useTimeZone()

  const itemsByDay = getCalendarGridItemsByDay({ items, locale, timezone })

  const agendaDays = getCalendarGridAgendaDays({ days, itemsByDay })

  return getHasCalendarGridAgendaDays(agendaDays) ? (
    <div className={styles.CalendarGridAgenda}>
      {agendaDays.map(day => (
        <CalendarGridAgendaDay
          day={day}
          items={itemsByDay[day.date]}
          key={day.date}
          today={today}
          onClickItem={onClickItem}
          onClickSecondaryLabel={onClickSecondaryLabel}
        />
      ))}
    </div>
  ) : isLoading ? (
    <CalendarGridAgendaSkeleton />
  ) : (
    <CalendarGridBodyMessage
      {...getCalendarGridAgendaMessage({ message, t })}
      className={styles.empty}
    />
  )
}

export default CalendarGridAgenda
